import { Box, CSS, Flex } from '@project44/manifest-ds';

interface Props {
  children: React.ReactNode | React.ReactNodeArray;
  navigation: React.ReactNode;
  css?: CSS;
  contentCss?: CSS;
  colorMode?: 'defaultBg' | 'brandBlue';
}

export const PageLayout: React.FC<Props> = ({
  children,
  navigation,
  css,
  contentCss,
  colorMode = 'brandBlue',
}) => (
  <Flex
    css={{
      backgroundColor: '$background-primary',
      height: '100vh',
      flexDirection: 'column',
      ...css,
    }}
  >
    {navigation}
    <Box
      css={{
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 1,
        background: `linear-gradient(to bottom, ${
          colorMode === 'defaultBg'
            ? '$colors$background-primary'
            : '$colors$background-top-nav'
        } 90px, transparent 90px 100%)`,
        ...contentCss,
      }}
    >
      {children}
    </Box>
  </Flex>
);
